import { useEffect, useState } from "react";
import { listProducts } from "lib/db";

/**
 * Shared read hook for the public site. All product listings/detail pages
 * pull from here so an admin add/edit/delete shows up everywhere without
 * per-page wiring.
 */
export function useProducts() {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;
    listProducts()
      .then((data) => {
        if (isMounted) setProducts(data);
      })
      .catch((err) => {
        if (isMounted) setError(err.message || "Could not load products.");
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return { products, isLoading, error };
}
